import { useMutation } from '@tanstack/react-query'
import { putContactInstrument } from 'services/ContactService'

export const usePutContactInstrumentMutation = () => {
  return useMutation({ mutationFn: putContactInstrument })
}
